import {Component, Input, OnInit} from '@angular/core';
import { UntypedFormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {FormContainerComponent} from '../form-container/form-container.component';
import { MatFormField, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'tw-form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['./form-input.component.css'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatError]
})
export class FormInputComponent extends FormContainerComponent implements OnInit {


    constructor( public fb: UntypedFormBuilder) {
        super(fb);
    }

    ngOnInit() {
    }

}
